<template>
    <div>
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <div slot="headerBtns">
                <button class="h_search_btn" @click="$router.push('/search')"></button>
            </div>
        </page-header>
        <page-header class="sub_header"></page-header>
        <gallery-write-component :galleryType="'galleryItemAdd'" :galleryKey="galleryKey"></gallery-write-component>
    </div>
</template>

<script>
import GalleryWriteComponent from "@/components/gallery/GalleryWriteComponent";

export default {
    name: "ItemAdd",
    mixins: [],
    components: {
        GalleryWriteComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            galleryKey: Number(this.$route.params.idx),
            // galleryKey: 0,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
